import { Box } from '@chakra-ui/react';
import { animated, useSpring } from '@react-spring/web';
export const AnimatedBox = animated(Box);
